import { tooltipClasses } from '@mui/material/Tooltip';
import { useTheme, type ThemeNames } from '../../theme';
import { type CSSObject } from '@emotion/react';

type TooltipStyles = Record<'tooltip' | 'popper', CSSObject>;

export const useTooltipStyles = (themeName?: ThemeNames): TooltipStyles => {
  const theme = useTheme(themeName);

  return {
    popper: {
      opacity: 0.3,
      transition: 'opacity 0.2s ease-in-out',
    },
    tooltip: {
      [`&[data-popper-placement^="right"] .${tooltipClasses.arrow}`]: {
        left: 1,
      },
      [`&[data-popper-placement^="left"] .${tooltipClasses.arrow}`]: {
        right: 1,
      },
      [`&[data-popper-placement^="bottom"] .${tooltipClasses.arrow}`]: {
        top: 1,
      },
      [`&[data-popper-placement^="top"] .${tooltipClasses.arrow}`]: {
        bottom: 1,
      },

      [`& .${tooltipClasses.tooltip}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: theme.spacing(1),
        minHeight: 32,
        gap: theme.spacing(2),
        backgroundColor: theme.tooltip.background,
        boxShadow: theme.shadows[1],
        backdropFilter: theme.backdropFilter.xlarge,
        borderRadius: theme.shape.radius8,
        fontSize: 15,
        userSelect: 'none',
      },

      [`& .${tooltipClasses.arrow}`]: {
        color: theme.tooltip.background,
      },

      [`& .${tooltipClasses.tooltipPlacementRight} .${tooltipClasses.arrow}::before`]:
        {
          borderBottomLeftRadius: '2px',
        },

      [`& .${tooltipClasses.tooltipPlacementLeft} .${tooltipClasses.arrow}::before`]:
        {
          borderTopRightRadius: '2px',
        },

      [`& .${tooltipClasses.tooltipPlacementTop} .${tooltipClasses.arrow}::before`]:
        {
          borderBottomRightRadius: '2px',
        },

      [`& .${tooltipClasses.tooltipPlacementBottom} .${tooltipClasses.arrow}::before`]:
        {
          borderTopLeftRadius: '2px',
        },
    },
  };
};
